export default __webpack_public_path__ + "static/gallery-art-jewelry-abc8b43d2ffe4b1d80dce4e7e3b2ba5f.jpg";